import React from "react";
import Box from "@/ui/atoms/Box";
import Typography from "@/ui/atoms/Typography";
import { Button } from "@proda-ai/ui-kit";
import type { CustomCellRendererProps } from "@/ui/molecules/Grid";
import type { TAddAccountRow } from "./gridEditChartOfAccounts";

type TAddAccountCellRendererProps = CustomCellRendererProps<TAddAccountRow> & {
    numOfExtractions: number;
    handleAddAccountButtonClicked: () => void;
    isEditable: boolean;
};

export const AddAccountCellRenderer: React.FC<TAddAccountCellRendererProps> = ({
    node,
    handleAddAccountButtonClicked,
}) => {
    const data = node.data;

    return (
        <Box
            sx={{
                ml: "3rem",
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
                gap: "2rem",
                height: "100%",
                alignItems: "center",
            }}
            data-testid={`add-account-${data?.code}`}
        >
            <Button
                pattern="secondary"
                isInline={true}
                size={"small"}
                px={3}
                onClick={handleAddAccountButtonClicked}
            >
                Add
            </Button>
            <Typography
                variant="body3"
                sx={{
                    color: "var(--text-color-disabled)",
                }}
            >
                Add an account to your chart of accounts
            </Typography>
        </Box>
    );
};
